import { http } from "../../../axios";
import { getCookie } from "../../../utils/cookie";
 const authToken = getCookie("auth_token");
class orbitService {

  getDetails(){
    return http().get(`user/details`);
  }
  getNotification(id:any){
    return http().get(`notification/${id}`);
  }

  deleteNotification(payload:any){
    return http().post(`notification/delete`,payload);
  }
  seenNotification(payload:any){
    return http().post(`notification/seen`,payload);
  }
  getGalaxy(payload:any) {
    return http().post(`orbit/galaxy`, payload);
  } 

 addOrbit(payload:any){
  return http().post(`orbit/add`, payload);
 }
  orbit(payload:any =null) {
    return http().post(`orbit/list`, payload);
  } 

  getAuthOrbit(id:any) {
    return http().get(`orbit/get/${id}`);
  } 
  getAuthPlanet(id:any){
    return http().get(`orbit/planet/get/${id}`);
  }
  getOrbit(payload:any) {
    return http().post(`orbit/get`,payload);
  } 
  editOrbit(payload:any) {
    return http().post(`orbit/edit`, payload);
  } 

  getProfile(id:any){
    return http().get(`user/get/${id}`);
  }

  updateProfile(payload:any){
    return http().post(`user/upsert`,payload);
  }

  inviteUser(payload:any){
    return http().post(`user/invite_user`,payload);
  }
  inviteUserValidation(payload:any){
    return http().post(`user/invite_user_validation`,payload);
  }
  
  acceptInvite(payload:any){
    return http().post(`user/accept_invite`,payload);
  }


  uploadprofileImg(data:any){
    return http().post(`user/update_user_profile/${data.id}`, data.value);
  }
  getProfileImg(id:any){
    return http().get(`user/get_user_image/${id}`);
  }

  getCitizenApprovalStatus(id:any){
    return http().get(`orbit/approval/status/${id}`);
  }
    updateApprovalStatus(payload:any){
    return http().post(`orbit/approval/update`,payload);
  }

}

export default new orbitService();